<div class="col-md-12 p-2 d-flex">
  <div class="col-md-7 p-0">
    <div class="label-name text-style mb-1">Card Holder Name</div>
    <div class="label-value text-style">
      {{ details?.card_holder_name }}
    </div>
  </div>
  <div class="col-md-5 p-0">
    <div class="label-name text-style mb-1">Card Number</div>
    <div class="label-value text-style">
      {{ details?.card_number }}
    </div>
  </div>
</div>
<div class="col-md-12 p-2 d-flex">
  <div class="col-md-7 p-0">
    <div class="label-name text-style mb-1">Funding Method</div>
    <div class="label-value text-style" style="text-transform: uppercase">
      {{ details?.funding_method }}
    </div>
  </div>
  <div class="col-md-5 p-0">
    <div class="label-name text-style mb-1">IP Country</div>
    <div class="label-value text-style">
      {{ details?.device_ip_address }}
    </div>
  </div>
</div>
